<h2 mat-dialog-title class="text-2xl font-semibold text-gray-900">Crop Suitability Report</h2>
<mat-dialog-content class="mat-typography">

  <mat-tab-group>

    <mat-tab *ngFor="let report of dssReports(); first as isFirst">
      <ng-template mat-tab-label>
        <span class="flex items-center gap-2" *ngIf="isFirst">
          <i class="fa fa-house-damage"></i>{{report.target.name}}
        </span>
        <span class="flex items-center gap-2" *ngIf="!isFirst">
          <i class="fa fa-vector-square"></i>{{report.target.name}}
        </span>
      </ng-template>
      <section class="py-6">
        <header class="mb-6 space-y-3">
          <div class="flex items-center justify-between">
            <span class="text-sm text-gray-700">
              Reporting Area: <b class="font-semibold text-gray-900">{{ report.target?.area | round: 1 }}</b> (ha)
            </span>
            <div>
              <button (click)="export(report)"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium text-sm shadow-sm">
                Export to PDF
              </button>
            </div>
          </div>
          <p *ngIf="report.totalAreaNotCovered >= 0.5"
            class="text-sm text-amber-700 bg-amber-50 p-3 rounded-lg border border-amber-200">
            Note that <b class="font-semibold">{{report?.totalAreaNotCovered | round: 1}}</b> (ha) of this area was
            missing Enterprise Suitability coverage so cannot be reported on
          </p>
        </header>

        <main class="overflow-hidden rounded-lg border border-gray-200 shadow-sm">
          <div class="overflow-x-auto">
            <table class="w-full divide-y divide-gray-200">
              <thead class="bg-gray-50 sticky top-0">
                @for (headerGroup of report.table.getHeaderGroups(); track $index) {
                  <tr>
                    @for (header of headerGroup.headers; track $index) {
                      @if(!header.isPlaceholder)
                      {
                      <th class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                        <ng-container *flexRender="
                   header.column.columnDef.header;
                  props:  header.getContext();
                  let header
                ">
                    </ng-container>
                      </th>
                      }

                    }
                  </tr>
                }
                <!-- <tr *ngFor="let headerGroup of report.table.getHeaderGroups()">
                  <th *ngFor="let header of headerGroup.headers" [attr.colspan]="header.colSpan"
                    class="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    <ng-container *ngIf="!header.isPlaceholder">
                      <ng-container *ngTemplateOutlet="
                          header.column.columnDef.header;
                          context: { $implicit: header.getContext() }
                        "></ng-container>
                    </ng-container>
                  </th>
                </tr> -->
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">

                @for (row of report.table.getRowModel().rows; track row.id) {
                <tr class="hover:bg-gray-50 transition-color">
                  @for (cell of row.getVisibleCells(); track cell.id) {
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    <ng-container *flexRender="
                  cell.column.columnDef.cell;
                  props:  getCellContext(cell, report);
                  let cell
                ">
                    </ng-container>
                  </td>
                  }
                </tr>
                }
              </tbody>
            </table>
          </div>
        </main>
      </section>
    </mat-tab>
  </mat-tab-group>

</mat-dialog-content>
<mat-dialog-actions class="border-t border-gray-200 pt-4">
  <footer>
    <button type="button"
      class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium text-sm"
      [mat-dialog-close]="false">
      Close
    </button>
  </footer>
</mat-dialog-actions>

<!-- Column Templates -->
<ng-template #rankHeader>Rank</ng-template>
<ng-template #rankCell let-context>
  <span class="font-medium text-gray-900">
    {{ context.row.original.rank | ordinal }}
  </span>
</ng-template>

<ng-template #imageHeader></ng-template>
<ng-template #imageCell let-context>
  <img class="w-12 h-12 object-contain rounded"
    [src]="'/assets/images/report-icons/' + context.row.original.crop.name + '.svg'"
    [alt]="context.row.original.crop.label" />
</ng-template>

<ng-template #cropHeader>Crop</ng-template>
<ng-template #cropCell let-context>
  <div class="flex items-center gap-1">
    <a target="_blank" [href]="fixUrl(context.row.original.crop.detailsLink)"
      class="text-blue-600 hover:text-blue-800 hover:underline font-medium">
      {{ context.row.original.crop.label }}
    </a>
    <sup>
      <a target="_blank" [href]="fixUrl(context.row.original.crop.rulesLink)" class="text-gray-500 hover:text-gray-700">
        <i class="fa fa-info-circle"></i>
      </a>
    </sup>
  </div>
</ng-template>

<ng-template #wellSuitedHeader>
  <div class="flex items-center gap-2">
    <span>Well Suited</span>
    <span class="text-xs font-normal text-gray-500">(ha)</span>
  </div>
</ng-template>
<ng-template #wellSuitedCell let-context>
  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
    {{ context.row.original.wellSuited | round: 1 }}
  </span>
</ng-template>

<ng-template #suitableHeader>
  <div class="flex items-center gap-2">
    <span>Suitable</span>
    <span class="text-xs font-normal text-gray-500">(ha)</span>
  </div>
</ng-template>
<ng-template #suitableCell let-context>
  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
    {{ context.row.original.suitable | round: 1 }}
  </span>
</ng-template>

<ng-template #moderatelySuitableHeader>
  <div class="flex items-center gap-2">
    <span>Moderately Suitable</span>
    <span class="text-xs font-normal text-gray-500">(ha)</span>
  </div>
</ng-template>
<ng-template #moderatelySuitableCell let-context>
  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
    {{ context.row.original.moderatelySuitable | round: 1 }}
  </span>
</ng-template>

<ng-template #unsuitableHeader>
  <div class="flex items-center gap-2">
    <span>Unsuitable</span>
    <span class="text-xs font-normal text-gray-500">(ha)</span>
  </div>
</ng-template>
<ng-template #unsuitableCell let-context>
  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
    {{ context.row.original.unsuitable | round: 1 }}
  </span>
</ng-template>

<ng-template #actionsHeader>Actions</ng-template>
<ng-template #actionsCell let-context>
  <button
    class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium text-sm shadow-sm"
    (click)="showCrop(context.row.original.crop, context.report.target)">
    Show on Map
  </button>
</ng-template>